export default __webpack_public_path__ + "static/media/image-4.fd569b34.png";